<template>
  <box-default>
    <box-list-filter :title="'Visualizar Churn por mês'">
      <input-select @contentValueSelected="value => filterValues.inputSelectMonth = value"
                    :options="filterSelects.month"
                    :label="'Mês'" :valueSelected="true" :contentValueSelected="filterValues.inputSelectMonth"
                    :col="3"/>
      <input-select @contentValueSelected="value => filterValues.inputSelectYear = value" :options="filterSelects.year"
                    :label="'Ano'" :valueSelected="true" :contentValueSelected="filterValues.inputSelectYear"
                    :col="3"/>
      <input-select @selectedOptionNumber="value => filterValues.inputSelectCollaborator = value"
                    :valueIsNumber="true"
                    :options="filterSelects.collaborator"
                    :label="'Colaboradores'" :col="3"/>
      <input-select @selectedOption="value => filterValues.inputSelectMotiveChurn = value"
                    :options="filterSelects.motiveChurn"
                    :label="'Motivo de Churn'" :col="3"/>
      <input-select @selectedOptionNumber="value => filterValues.inputSelectLifeTime = value"
                    :valueIsNumber="true"
                    :options="filterSelects.lifeTime"
                    :label="'Filtrar por LT'" :col="3"/>
      <input-text v-if="filterValues.inputSelectLifeTime" :smallInput="true" :input-error="validateFilters.firstValue"
                  @contentText="value => filterValues.firstValue = value"
                  mask="###" col="1" type="text" placeholder="Mês" label=""
                  :is-required="true"/>
      <div v-if="filterValues.inputSelectLifeTime === 3" class="col-md-1 text-lt"> há</div>
      <input-text v-if="filterValues.inputSelectLifeTime === 3" :smallInput="true"
                  :input-error="validateFilters.secondValue"
                  @contentText="value => filterValues.secondValue = value"
                  mask="###" col="1" type="text" placeholder="Mês"
                  label=""
                  :is-required="true"/>
      <span v-if="filterValues.inputSelectLifeTime" class="col-md-1 text-lt">Meses</span>
      <input-checkbox @valueCheckbox="value => filterValues.inputCheckboxTrials = value" :label="'Mostrar Trials'"
                      :is-checked="false" :col="12"/>
      <btn-search @emit-click="getList()" :loading="loadingList" :have-loading="false" :label="'Pesquisar'"/>
    </box-list-filter>
    <waiting-list :loading-content="loadingList">
      <mini-card-details v-if="contentList.listBody.length" :title="'NET Churn'"
                         :resumeTitle="dataCode.netChurn | formatMoneyReal" :col="3"/>
      <mini-card-details v-if="contentList.listBody.length" :title="'% NET Churn'"
                         :resumeTitle="dataCode.netChurnPercentage"
                         :contentDetailsList="cardDetails.netChurn"
                         :col="3"/>
      <mini-card-details v-if="contentList.listBody.length" :title="'Logo Churn'" :resumeTitle="dataCode.logoChurn"
                         :col="3"/>
      <mini-card-details v-if="contentList.listBody.length" :title="'% Logo Churn'"
                         :resumeTitle="dataCode.logoChurnPercentage"
                         :contentDetailsList="cardDetails.logoChurn"
                         :col="3"/>
      <box-listing @emit-excel="createExcel()" :empty-state="!contentList.listBody.length" :title="'Lista de Churns'"
                   :haveExcel="true"
                   :columns-list-header="contentList.listHeader">
        <template v-for="(value, index) in contentList.listBody">
          <tr class="churns" :key="index">
            <td class="churns-employee">
              <router-link :to="'/detalhes-da-empresa/' + value.companyId + '/' + value.companyContext">
                {{ value.companyName }}
              </router-link>
            </td>
            <td class="churns-collaborator">{{ value.totalEmployee }}</td>
            <td class="churns-mrr">{{ value.monthlyRecurringRevenue }}</td>
            <td class="churns-lt">{{ value.lifeTime }}</td>
            <td class="churns-datechurn">{{ value.churnDate | formatDate }}</td>
            <td class="churns-motive">{{ value.churnMotive }}</td>
            <td class="churns-details">
              <div class="row-fluid">
                <span @click="toggleExpanded(index)" :data-target="`#col${index}-row${index}`" data-toggle="collapse">
                  Ver detalhes
                  <ion-icon v-if="!value.isExpanded" name="chevron-down-outline"></ion-icon>
                  <ion-icon v-else name="chevron-up-outline"></ion-icon>
                </span>
              </div>
            </td>
          </tr>

          <tr :key="index + 'r'" :id="`col${index}-row${index}`" class="collapse custom-collapse" style="width: 100%;">
            <td colspan="8" class="collapse-td">
              <div class="collapse-details">
                <div class="collapse-group">
                  <span>
                    Vendedor: <b>{{ value.userName }}</b>
                  </span>
                  <span>
                  Data de início: <b>{{ value.firstSubscriptionDate | formatDate }}</b>
                  </span>
                </div>
                <div class="collapse-group">
                  <span>
                    Observação motivo: <b>{{ value.notes }}</b>
                  </span>
                </div>
                <div class="collapse-group collapse-remove">
                  <span @click="removeChurn(index)">
                    <ion-icon name="trash-outline"></ion-icon>Remover churn da lista
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </box-listing>
    </waiting-list>
  </box-default>
</template>

<script>
import fullLoading from "../../components/default/fullLoading.vue";
import boxDefault from "../../components/layouts/boxDefault.vue";
import BoxListFilter from "../../components/layouts/boxListFilter.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {GET_CHURN_CATEGORY, LIST_CHURNS, UPDATE_TICKETS} from "../../../../urlConfig";
import InputText from "../../components/inputs/inputText.vue";
import {MONTHS, YEARS, TOTAL_COLABORATORS_INT} from '../../../../assets/js/index'
import MiniCardDetails from "../../components/layouts/miniCardDetails.vue";
import WaitingList from "../../components/layouts/waitingList.vue";
import BoxListing from "../../components/layouts/boxListing.vue";
import {debounce} from 'lodash'
import swal from "sweetalert";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import moment from "moment";

export default {
  name: "list-churns",
  components: {
    BoxListing,
    WaitingList,
    MiniCardDetails,
    InputText,
    InputCheckbox,
    BtnSearch,
    InputSelect,
    BoxListFilter,
    fullLoading,
    boxDefault,
  },
  data() {
    return {
      dataCode: '',
      loading: false,
      loadingList: false,
      filterSelects: {
        month: [
          {
            name: 'Todos',
            id: ''
          },
          ...MONTHS,
        ],
        year: [
          {
            name: 'Todos',
            id: ''
          },
          ...YEARS
        ],
        collaborator: [
          {
            name: 'Todos',
            id: 0
          },
          ...TOTAL_COLABORATORS_INT
        ],
        motiveChurn: [
          {
            name: 'Todos',
            id: '',
          }
        ],
        lifeTime: [
          {
            name: 'Todos',
            id: 0,
          },
          {
            name: 'Menor que',
            id: 1,
          },
          {
            name: 'Maior que',
            id: 4,
          },
          {
            name: 'Entre',
            id: 3,
          },
        ]
      },
      filterValues: {
        inputSelectMonth: '',
        inputSelectYear: '',
        inputSelectCollaborator: 0,
        inputSelectMotiveChurn: '',
        inputCheckboxTrials: false,
        inputSelectLifeTime: 0,
        firstValue: 0,
        secondValue: 0,
      },
      validateFilters: {
        firstValue: false,
        secondValue: false,
      },
      cardDetails: {
        netChurn: [
          {
            name: 'MRR Total:',
            value: 'R$ 150.000.00'
          },
          {
            name: 'MRR de Churns:',
            value: 'R$ 14.548,74'
          }
        ],
        logoChurn: [
          {
            name: 'Total de clientes:',
            value: '1500'
          },
          {
            name: 'Total de Churns:',
            value: '15'
          }
        ]
      },
      contentList: {
        listHeader: [
          'Empresa',
          'Colaboradores',
          'MRR',
          'LT',
          'Data de Churn',
          'Motivo do Churn',
          'Ações',
        ],
        listBody: []
      },
    };
  },
  methods: {
    getList() {
      this.validateFilters.firstValue = false;
      this.validateFilters.secondValue = false;

      let url = LIST_CHURNS + '?month=' + this.filterValues.inputSelectMonth + '&year=' + this.filterValues.inputSelectYear

      if (this.filterValues.inputSelectCollaborator) {
        url += '&employeeRange=' + this.filterValues.inputSelectCollaborator
      }
      if (this.filterValues.inputSelectMotiveChurn) {
        url += '&churnCategory=' + this.filterValues.inputSelectMotiveChurn
      }
      if (this.filterValues.inputCheckboxTrials) {
        url += '&showTrial=' + this.filterValues.inputCheckboxTrials
      }
      if (this.filterValues.inputSelectLifeTime) {
        url += '&numericFilterRange=' + this.filterValues.inputSelectLifeTime

        if ([1, 4].includes(this.filterValues.inputSelectLifeTime)) {
          if (this.filterValues.firstValue) {
            url += '&firstValue=' + this.filterValues.firstValue
          } else {
            return this.validateFilters.firstValue = true;
          }
        }

        if (this.filterValues.inputSelectLifeTime === 3) {
          if (this.filterValues.firstValue) {
            url += '&firstValue=' + this.filterValues.firstValue
          } else {
            return this.validateFilters.firstValue = true;
          }

          if (this.filterValues.secondValue) {
            url += '&secondValue=' + this.filterValues.secondValue
          } else {
            return this.validateFilters.secondValue = true;
          }
        }
      }

      this.loadingList = true

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT LIST_CHURNS:", response.data);

        this.loadingList = false;
        this.dataCode = response.data;
        this.contentList.listBody = response.data.listCompanyChurnDTO.map(item => {
          return {
            ...item,
            isExpanded: false
          }
        });

        this.cardDetails.netChurn[0].value = response.data.monthlyRecurringRevenueLastMonth;
        this.cardDetails.netChurn[1].value = response.data.churnMRR;
        this.cardDetails.logoChurn[0].value = response.data.activeClientsLastMonth;
        this.cardDetails.logoChurn[1].value = response.data.totalChurns;

      }).catch((reason) => {
        this.loadingList = false;
        swal("Aviso", reason.response.data, "error");
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });

    },
    getMotiveChurn() {
      REQUEST_SERVICE.get(GET_CHURN_CATEGORY).then((response) => {
        UTIL_SERVICE.console("RESULT GET_CHURN_CATEGORY:", response.data);
        this.filterSelects.motiveChurn.push(...response.data);
      }).catch((reason) => {
        console.log('Erro ao requisitar typesMotive', reason)
      });
    },
    toggleExpanded: debounce(function (index) {
      this.contentList.listBody[index].isExpanded = !this.contentList.listBody[index].isExpanded
    }, 250),
    removeChurn(index) {
      swal({
        title: "Remover",
        text: "Deseja remover esse churn?",
        icon: "warning",
        buttons: {
          cancel: "Não",
          catch: {
            text: "Sim",
            value: "yes",
          }
        }
      }).then(value => {
        if (value === 'yes') {
          console.log('sim', index)
        } else {
          swal("Cancelado!", {
            icon: "error",
          });
        }
      });
    },
    setFilterCurrent() {
      const date = new Date();
      this.filterValues.inputSelectMonth = date.getMonth() + 1;
      this.filterValues.inputSelectYear = date.getFullYear();
    },
    createExcel() {
      let headValue = ["Empresa", "Colaboradores", "MRR", "LT", "Data de Churn", "Motivo do Churn", "Vendedor", "Data de início", "Observação motivo"];
      let bodyValue = [];

      this.contentList.listBody.map((value, index) => {
        bodyValue.push([value.companyName, value.totalEmployee, value.monthlyRecurringRevenue, value.lifeTime, moment(value.churnDate).format('DD/MM/YYYY'), value.churnMotive, value.userName, moment(value.firstSubscriptionDate).format('DD/MM/YYYY'), value.notes]);
      });

      window.downloadListExcel(headValue, bodyValue, "Relatório de Churns por mês");
    }
  },
  beforeMount() {
    this.setFilterCurrent();
    this.getMotiveChurn();
    this.getList();
  }
};
</script>

<style lang="scss" scoped>

.churns {
  td {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    font-weight: 400;
    font-size: 16px;
    color: #3A424E;
    vertical-align: inherit !important;

    a {
      font-weight: 400;
      font-size: 14px;
      color: #2F23D6;
      text-decoration: none;
      border-bottom: 1px solid transparent;
      transition: .2s;

      &:hover {
        border-color: #2F23D6;
      }
    }
  }

  &-employee {
    min-width: 100px;
    max-width: 235px;
    width: max-content;
    word-break: break-word;
  }

  &-motive {
    min-width: 100px;
    max-width: 235px;
    width: max-content;
    word-break: break-word;
  }

  &-details {

    span {
      display: flex;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      color: #2F23D6;
      text-decoration: none;
      border-bottom: 1px solid transparent;
      transition: .2s;
      align-items: center;
      cursor: pointer;

      &:hover {
        border-color: #2F23D6;
      }

      ion-icon {
        margin-left: 2px;
        font-size: 18px;
      }
    }
  }
}

.custom-collapse {
  width: 100%;
}

.collapse {
  &-td {
    border-top: none;
  }

  &-td > &-details {
    display: flex;
    justify-content: space-between;
    border: 1px solid #E6E9EC;
    border-radius: 10px !important;
    padding: 20px 15px;
    margin-bottom: 10px;
  }

  &-td > &-details > &-group {
    display: flex;
    flex-direction: column;
    max-width: 413px;
  }

  &-td > &-details > &-remove {
    justify-content: center;

    span {
      display: flex;
      align-content: center;
      color: #FF445D;
      font-size: 14px;
      font-weight: 400;
      transition: .2s;
      padding-bottom: 2px;
      border-bottom: 1px solid transparent;
      cursor: pointer;

      &:hover {
        border-color: #FF445D;
      }

      ion-icon {
        font-size: 20px;
        margin-right: 2px;
      }
    }
  }
}

.text-lt {
  width: 50px;
  font-size: 14px;
  font-weight: 400;
  color: #191919;
  margin-top: 32px;
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/listChurns.vue